/* eslint-disable function-paren-newline */ class $46c5220051a5e3d1$export$97f0fb808b782731 {
    constructor(size = 4){
        this.size = size;
        this.score = 0;
        this.gameField = Array.from({
            length: this.size
        }, ()=>Array(this.size).fill(0));
    }
    removeZeros(arr) {
        return arr.filter((row)=>row !== 0);
    }
}


const $09e991522ca7e64e$var$game = new (0, $46c5220051a5e3d1$export$97f0fb808b782731)();
const $09e991522ca7e64e$var$start = document.querySelector(".start");
const $09e991522ca7e64e$var$fieldHtml = document.querySelectorAll(".field-row");
const $09e991522ca7e64e$var$gameScore = document.querySelector(".game-score");
const $09e991522ca7e64e$var$startMessage = document.querySelector(".message-start");
const $09e991522ca7e64e$var$loseMessage = document.querySelector(".hidden");
const $09e991522ca7e64e$var$winner = document.querySelector(".message-win");
const $09e991522ca7e64e$var$size = $09e991522ca7e64e$var$game.size;
let $09e991522ca7e64e$var$score = $09e991522ca7e64e$var$game.score;
let $09e991522ca7e64e$var$gameField = $09e991522ca7e64e$var$game.gameField;
function $09e991522ca7e64e$var$addLayoutOnHtml() {
    for(let row = 0; row < $09e991522ca7e64e$var$size; row++)for(let cell = 0; cell < $09e991522ca7e64e$var$size; cell++){
        if ($09e991522ca7e64e$var$gameField[row][cell] === 2048) $09e991522ca7e64e$var$winner.classList.remove("hidden");
        const setFieldHtml = $09e991522ca7e64e$var$fieldHtml[row].children[cell];
        const currentValue = setFieldHtml.textContent = $09e991522ca7e64e$var$gameField[row][cell] || "";
        setFieldHtml.className = currentValue ? `field-cell field-cell--${currentValue}` : "field-cell";
    }
    $09e991522ca7e64e$var$gameScore.innerText = $09e991522ca7e64e$var$score;
}
function $09e991522ca7e64e$var$addRandomNumber() {
    const row = Math.floor(Math.random() * $09e991522ca7e64e$var$size);
    const cell = Math.floor(Math.random() * $09e991522ca7e64e$var$size);
    if ($09e991522ca7e64e$var$gameField[row][cell] === 0) $09e991522ca7e64e$var$gameField[row][cell] = Math.random() < 0.1 ? 4 : 2;
    else $09e991522ca7e64e$var$addRandomNumber();
}
function $09e991522ca7e64e$var$checkGameOver() {
    let copyGameFiel = [
        ...$09e991522ca7e64e$var$gameField
    ];
    let hasMoveRL = false;
    let hasMoveUD = false;
    let comeIn = false;
    const result = copyGameFiel.every((r)=>copyGameFiel.every((_, i)=>r[i] > 0));
    if (result) {
        comeIn = true;
        for(let row = 0; row < 4; row++){
            const eachRow = copyGameFiel[row];
            for(let cell = 0; cell < 4; cell++)if (eachRow[cell] === eachRow[cell + 1]) hasMoveRL = true;
        }
        copyGameFiel = $09e991522ca7e64e$var$transpose(copyGameFiel);
        for(let row = 0; row < 4; row++){
            const eachRow = copyGameFiel[row];
            for(let cell = 0; cell < 4; cell++)if (eachRow[cell] === eachRow[cell + 1]) hasMoveUD = true;
        }
    }
    if (!hasMoveRL && !hasMoveUD && comeIn) $09e991522ca7e64e$var$loseMessage.classList.remove("hidden");
}
function $09e991522ca7e64e$var$transpose(arr) {
    return arr.map((_, index)=>arr.map((row)=>row[index]));
}
function $09e991522ca7e64e$var$uniteCells(row) {
    let moved = false;
    for(let i = 0; i < row.length - 1; i++){
        if (row[i] === row[i + 1]) {
            row[i] *= 2;
            row.splice(i + 1, 1);
            $09e991522ca7e64e$var$score += row[i];
            moved = true;
        } else if (row[i] === 0 && row[i + 1] === 0) moved = false;
    }
    while(row.length < $09e991522ca7e64e$var$size)row.push(0);
    return {
        row: row,
        moved: moved
    };
}
function $09e991522ca7e64e$var$clickArrowLeft() {
    let hasMoved = false;
    for(let row = 0; row < $09e991522ca7e64e$var$size; row++){
        const copyGameField = [
            ...$09e991522ca7e64e$var$gameField[row]
        ];
        const removeZero = $09e991522ca7e64e$var$game.removeZeros($09e991522ca7e64e$var$gameField[row]);
        const move = $09e991522ca7e64e$var$uniteCells(removeZero);
        $09e991522ca7e64e$var$gameField[row] = removeZero;
        if (move.moved || JSON.stringify(copyGameField) !== JSON.stringify(move.row)) hasMoved = true;
    }
    if (hasMoved) {
        $09e991522ca7e64e$var$addRandomNumber();
        $09e991522ca7e64e$var$checkGameOver();
    }
    $09e991522ca7e64e$var$addLayoutOnHtml();
}
function $09e991522ca7e64e$var$clickArrowRight() {
    let hasMoved = false;
    for(let row = 0; row < $09e991522ca7e64e$var$size; row++){
        const copyOfGameField = [
            ...$09e991522ca7e64e$var$gameField[row]
        ];
        const removeZero = $09e991522ca7e64e$var$game.removeZeros($09e991522ca7e64e$var$gameField[row].reverse());
        const newRow = $09e991522ca7e64e$var$uniteCells(removeZero);
        $09e991522ca7e64e$var$gameField[row] = newRow.row.reverse();
        if (newRow.moved || JSON.stringify(copyOfGameField) !== JSON.stringify(newRow.row)) hasMoved = true;
    }
    if (hasMoved) {
        $09e991522ca7e64e$var$addRandomNumber();
        $09e991522ca7e64e$var$checkGameOver();
    }
    $09e991522ca7e64e$var$addLayoutOnHtml();
}
function $09e991522ca7e64e$var$clickArrowUp() {
    let hasMoved = false;
    $09e991522ca7e64e$var$gameField = $09e991522ca7e64e$var$transpose($09e991522ca7e64e$var$gameField);
    for(let row = 0; row < $09e991522ca7e64e$var$size; row++){
        const copyOfGameField = [
            ...$09e991522ca7e64e$var$gameField[row]
        ];
        const removeZero = $09e991522ca7e64e$var$game.removeZeros($09e991522ca7e64e$var$gameField[row]);
        const newRow = $09e991522ca7e64e$var$uniteCells(removeZero);
        $09e991522ca7e64e$var$gameField[row] = newRow.row;
        if (newRow.moved || JSON.stringify(copyOfGameField) !== JSON.stringify(newRow.row)) hasMoved = true;
    }
    $09e991522ca7e64e$var$gameField = $09e991522ca7e64e$var$transpose($09e991522ca7e64e$var$gameField);
    if (hasMoved) {
        $09e991522ca7e64e$var$addRandomNumber();
        $09e991522ca7e64e$var$checkGameOver();
    }
    $09e991522ca7e64e$var$addLayoutOnHtml();
}
function $09e991522ca7e64e$var$clickArrowDown() {
    let hasMoved = false;
    $09e991522ca7e64e$var$gameField = $09e991522ca7e64e$var$transpose($09e991522ca7e64e$var$gameField);
    for(let row = 0; row < $09e991522ca7e64e$var$size; row++){
        const copyOfField = [
            ...$09e991522ca7e64e$var$gameField[row]
        ];
        const removeZero = $09e991522ca7e64e$var$game.removeZeros($09e991522ca7e64e$var$gameField[row].reverse());
        const newRow = $09e991522ca7e64e$var$uniteCells(removeZero);
        $09e991522ca7e64e$var$gameField[row] = newRow.row.reverse();
        if (newRow.moved || JSON.stringify(copyOfField) !== JSON.stringify(newRow.row)) hasMoved = true;
    }
    $09e991522ca7e64e$var$gameField = $09e991522ca7e64e$var$transpose($09e991522ca7e64e$var$gameField);
    if (hasMoved) {
        $09e991522ca7e64e$var$addRandomNumber();
        $09e991522ca7e64e$var$checkGameOver();
    }
    $09e991522ca7e64e$var$addLayoutOnHtml();
}
function $09e991522ca7e64e$var$handleArrows(e) {
    switch(e.key){
        case "ArrowLeft":
            $09e991522ca7e64e$var$clickArrowLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$clickArrowRight();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$clickArrowUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$clickArrowDown();
            break;
        default:
            break;
    }
}
$09e991522ca7e64e$var$start.addEventListener("click", ()=>{
    document.addEventListener("keydown", $09e991522ca7e64e$var$handleArrows);
    $09e991522ca7e64e$var$startMessage.hidden = true;
    if ($09e991522ca7e64e$var$start.innerText === "Start") {
        $09e991522ca7e64e$var$start.innerText = "Restart";
        $09e991522ca7e64e$var$start.classList.replace("start", "restart");
    } else {
        $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
        $09e991522ca7e64e$var$score = 0;
        $09e991522ca7e64e$var$gameField = $09e991522ca7e64e$var$gameField = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
    }
    $09e991522ca7e64e$var$addRandomNumber();
    $09e991522ca7e64e$var$addRandomNumber();
    $09e991522ca7e64e$var$addLayoutOnHtml();
});


//# sourceMappingURL=index.a018b5f5.js.map
